import { useTranslation } from 'react-i18next';

import {
  BoxExpand,
  Button,
  ButtonsWrapper,
  CheckboxInput,
  Drawer,
  Form,
} from '@thinknet-gmbh/platform-common-ui';
import { ProcessTaskStatusesEnum, ProcessTaskTypesEnum } from '@thinknet-gmbh/platform-common';


import { getFilteredData, getInitialFilterData } from './tasks-table-filter.helpers';
import { ITasksFilter, ITableFilterProps } from '../../../../task-manager.interfaces';

import { FormContentWrapper } from './tasks-table-filter.styles';

const TasksTableFilter = ({ isOpened, onClose, filters, setFilters }: ITableFilterProps) => {
  const { t } = useTranslation(['common', 'vacancies']);

  const onFinish = (values: any) => {
    setFilters((oldValue: ITasksFilter) => ({
      ...oldValue,
      ...getFilteredData(values),
    }));
    onClose();
  };

  const initialFilterData = getInitialFilterData(filters);

  return (
    <Drawer visible={isOpened} onClose={onClose} title={t('common:buttons.filterBy')}>
      <Form layout="vertical" onFinish={onFinish} initialValues={initialFilterData}>
        <FormContentWrapper>
          <BoxExpand
            title={t('processBuilder:tasks.labels.source')}
            isExpandedWhenEdit={!!filters.types?.length}
          >
            {Object.values(ProcessTaskTypesEnum).map(type => (
              <Form.Item key={type} name={['types', type]} valuePropName="checked">
                <CheckboxInput>
                  {t(`processBuilder:tasks.filtersTypes.${type.toLowerCase()}`)}
                </CheckboxInput>
              </Form.Item>
            ))}
          </BoxExpand>
          <BoxExpand
            title={t('common:labels.status')}
            isExpandedWhenEdit={!!filters.statuses?.length}
          >
            {Object.values(ProcessTaskStatusesEnum).map(status => (
              <Form.Item key={status} name={['statuses', status]} valuePropName="checked">
                <CheckboxInput>
                  {t(`processBuilder:tasks.filterStatuses.${status.toLowerCase()}`)}
                </CheckboxInput>
              </Form.Item>
            ))}

            <Form.Item key={'overdue'} name={['overdue', 'overdue']} valuePropName="checked">
              <CheckboxInput>{t(`processBuilder:tasks.filterStatuses.overdue`)}</CheckboxInput>
            </Form.Item>
          </BoxExpand>
          <ButtonsWrapper marginTop={16}>
            <Button type="primary" htmlType="submit">
              {t('common:buttons.apply')}
            </Button>
            <Button
              onClick={() => {
                onClose();
                setFilters({});
              }}
            >
              {t('common:buttons.cancel')}
            </Button>
          </ButtonsWrapper>
        </FormContentWrapper>
      </Form>
    </Drawer>
  );
};

export default TasksTableFilter;
